import React from 'react'
import {ALIGNMENT, SKIN, VARIANT} from 'wix-ui-tpa/Tabs'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Tabs} from '../../../../commons/enums'
import {Tabs as TabsComp} from '../styled-components/tabs'
import {EventTabsProps} from '.'

export const EventsTabs = ({
  tab,
  setTab,
  upcomingEventsTabLabel,
  pastEventsTabLabel,
  mobile,
  rtl,
  closeAllEvents,
}: EventTabsProps) => {
  const onTabClick = (newTab: Tabs) => {
    setTab(newTab)
    closeAllEvents()
  }

  return (
    <TabsComp
      data-hook={DH.EVENTS_MA_PAGE_EVENT_LIST_TABS}
      items={[{title: upcomingEventsTabLabel}, {title: pastEventsTabLabel}]}
      onTabClick={onTabClick}
      alignment={mobile ? ALIGNMENT.center : rtl ? ALIGNMENT.right : ALIGNMENT.left}
      variant={mobile ? VARIANT.fullWidth : VARIANT.fit}
      skin={mobile ? SKIN.fullUnderline : SKIN.clear}
      activeTabIndex={tab}
      mobile={mobile}
    />
  )
}
